module.exports = __webpack_public_path__ + "img/DE00997.1a6eb3d9.png";